import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    color: 'white',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
  },
  rowWrapper: {
    mx: '0.5',
    px: '2',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'transparent',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    color: 'white',
    _before: {
      borderColor: 'blackAlpha.400',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      top: '-1px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
    px: '2',
    _before: {
      display: 'none',
    },
  },
  rowWrapperWithBtn: {
    borderColor: 'alpha.700',
    borderTopWidth: '1px',
  },
  tab: {
    bg: 'alpha.200',
    color: 'white',
    fontSize: '2xs',
    fontWeight: 'extrabold',
    _notFirst: { borderLeftWidth: '1px', borderLeftColor: 'alpha.700' },
    _selected: {
      bg: 'blackAlpha.500',
      borderBottom: '2px solid',
      borderBottomColor: 'beta.300',
      color: 'beta.300',
    },
  },
};
